module.exports = __webpack_public_path__ + "static/media/symbol-prize_white.ffa6fae0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-prize_white.svg
// module id = ./src/assets/images/symbol-prize_white.svg
// module chunks = 0